import React from 'react';
import IntellendLogo from '@/components/IntellendLogo';

interface BrandedJourneyHeaderProps {
  className?: string;
  title?: string;
  subtitle?: string;
}

/**
 * BrandedJourneyHeader Component
 *
 * Generic branded header for journey pages with Intellend logo and customizable text.
 * Features a green background with white text and logo.
 * Can be used for any BAP journey (Caprion, PetPooja, etc.)
 */
const BrandedJourneyHeader: React.FC<BrandedJourneyHeaderProps> = ({
  className = '',
  title = 'Financial Solutions for Indian MSMEs',
  subtitle = 'Access business loans tailored for your growth needs. Quick approvals, competitive rates, and flexible terms.'
}) => {
  return (
    <header className={`bg-intellend-green text-white ${className}`}>
      <div className="container mx-auto px-4 py-8 md:py-12">
        {/* Logo Container */}
        <div className="bg-white px-2 py-1 rounded-lg inline-block mb-6 md:mb-8">
          <IntellendLogo size="sm" />
        </div>

        {/* Heading */}
        <h1 className="text-2xl md:text-4xl font-bold mb-3 md:mb-4">
          {title}
        </h1>

        {/* Subheading */}
        <p className="text-base md:text-lg opacity-90 max-w-2xl">
          {subtitle}
        </p>
      </div>
    </header>
  );
};

export default BrandedJourneyHeader;
